/*
 * Copyright (c) 2018-2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { createBrowserHistory } from "history";

const basename = "/auth/";
const history = createBrowserHistory({
  basename,
});

export default history;
